/**
 * Sprint Redesign v1 · Phase 2+ · Baustein 6 (Do 03.09.2026, 19:00).
 *
 * /anliegen — eigenständige Seite (nicht mehr Redirect).
 * Rendert die bestehende DashboardAnliegen-Component INSIDE Redesign-Layout,
 * damit Sidebar + TopBar konsistent bleiben. Free-3/Tag-Sperre + Pro-Unlimited
 * bleiben unverändert (Backend aus Phase 3).
 *
 * Pricing-konform: keine €-Beträge außer dem 39-€-Anker.
 */
import React from "react";
import RedesignLayout from "@/components/redesign/RedesignLayout";
import DashboardAnliegen from "@/pages/DashboardAnliegen";

export default function PageAnliegen() {
  return (
    <RedesignLayout>
      <div data-testid="page-anliegen">
        <DashboardAnliegen />
      </div>
    </RedesignLayout>
  );
}
